<beaconstac-wait-loader *ngIf="!showErrorScreen" class="loader" [loadingText]="'Setting up your account...'"></beaconstac-wait-loader>

<app-error-screen *ngIf="isMobileDevice && showErrorScreen" [showErrorScreen]="showErrorScreen" [errorMessage]="errorMessage" [errorTitle]="errorTitle" [primaryCtaText]="primaryCtaText" (errorCtaClicked)="handleErrorRouting()"></app-error-screen>
<app-toast [toastWidth]="'500px'" #customSignupToast></app-toast>
